import { PropsWithChildren, FC } from 'react'
import { CloseOutlined, ReloadOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'

import styles from './styles.css'

type DeleteFollowerType = {
    id: number
    isDelete: boolean
    isAdded: boolean
    handleRemove: (id: number) => void
    handleUndoRemove: (id: number) => void
}

const DeleteFollower: FC<PropsWithChildren<DeleteFollowerType>> = ({
    id,
    isDelete,
    isAdded,
    handleRemove,
    handleUndoRemove,
}) => {
    return isDelete ? (
        <Box onClick={() => handleUndoRemove(id)}>
            <Text className={styles.undoDelete}>To be removed</Text>
            <Tooltip title="Undo remove" className={styles.deleteIcon}>
                <ReloadOutlined className={styles.followersIconStyle} />
            </Tooltip>
        </Box>
    ) : (
        <Box onClick={() => handleRemove(id)}>
            {isAdded && (
                <Text className={styles.newAddedFollower}>To be added</Text>
            )}
            <Tooltip title="Remove follower">
                <CloseOutlined className={styles.followersIconStyle} />
            </Tooltip>
        </Box>
    )
}

export default DeleteFollower
